import React, { useContext } from 'react';
import { AuthContext } from '../../appContext';
import { instructorAdmin, instructor, student } from '../../routes/navItems';
import InstructorDashboard from './Instructor';
import StudentDashboard from './Student';

/**
 * The dashboard shell. Which sidebar and footer a user sees follows from
 * their account, and the routed screen renders into the outlet inside.
 */
const Dashboard = () => {
  const { userInfo } = useContext(AuthContext);
  if (!userInfo) return null;

  const { accountType, role } = userInfo;
  if (accountType !== 'TEACHER') return <StudentDashboard routes={student} />;

  return <InstructorDashboard routes={role === 'ADMIN' ? instructorAdmin : instructor} />;
};

export default Dashboard;
